import { LoadablePaint } from '@confluence/loadable';

export const LazyConfigurationPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfigurationContainer" */ '../src/Configuration/ConfigurationPage'
			)
		).ConfigurationPage,
});
